module.exports = __webpack_public_path__ + "img/ky.a6f3b941.svg";